import { useQuery } from '@tanstack/react-query';
import { StatCardGrid } from '@/components/common/StatCardGrid';
import { teacherSummaryQueryOptions } from '../api/teacherSubmissions.api';
import { TEACHER_SUMMARY_CARDS } from '../constants/teacherSubmission.constants';
import type { TeacherSummaryParams } from '../types/teacherSubmission.types';

interface TeacherSubmissionSummaryCardsProps {
  params: TeacherSummaryParams;
}

export function TeacherSubmissionSummaryCards({ params }: TeacherSubmissionSummaryCardsProps) {
  const { data, isLoading, isError } = useQuery(teacherSummaryQueryOptions(params));

  return (
    <StatCardGrid
      stats={TEACHER_SUMMARY_CARDS.map((card) => ({ ...card, value: data?.[card.key] }))}
      isLoading={isLoading}
      isError={isError}
    />
  );
}
